import Group262 from "../../../assets/img/Group262.svg";
import "./index.css";

export const ImgContent = () => {
  return (
    <div className="imgContainer">
      <img src={Group262} alt="" />
    </div>
  );
};
